export default "__VITE_ASSET__BZeewsOs__"